import { sdkLoggerInterface as log } from '../Logger/Logger';
export class UserTailoring {
    constructor(appId, user, coreFlagMgr) {
        this.appId = appId;
        this.user = user;
        this.coreFlagMgr = coreFlagMgr;
    }
    /**
     * Register a strategy for your miniapp.
     * @param flagStrategy What strategy would you like to register for said miniapp.
     * @example
     * ```typescript
     * // App.tsx
     * import { useUser } from '@nab/nab-x-react';
     * ...
     * const user = useUser();
     *
     * useEffect(() => {
     *  try {
     *      (async () => {
     *          await user.setFlagStrategy(new LaunchDarklyFlagStrategy('your-api-key-for-launchdarkly'));
     *           setShowGraphQLComp(user.checkFlag('graphql', false));
     *       })();
     *   } catch (e) {
     *       new Error('Error: Unable to get token');
     *   }
     *  }, [user]);
     * ```
     */
    async setFlagStrategy(flagStrategy) {
        return this.coreFlagMgr.setFlagStrategy(this.user, flagStrategy, this.appId);
    }
    /**
     * Retrieve the flag value.
     * @param flagName The flag value you want to retrieve.
     * @param defaultValue The value you wish to return in case of an uncaught exception or if the strategy has not been initialised.
     */
    checkFlag(flagName, defaultValue) {
        const result = this.coreFlagMgr.checkFlag(this.appId, flagName, defaultValue);
        log.info(`checkFlag: ${flagName} = ${result}`);
        return result;
    }
    areFlagsReady() {
        return this.coreFlagMgr.areFlagsReady(this.appId);
    }
    whenFlagsReady() {
        return this.coreFlagMgr.whenFlagsReady(this.appId);
    }
    hasCapability(capability) {
        return true;
    }
}
//# sourceMappingURL=UserTailoring.js.map